import { Link } from 'react-router-dom';
import AddBubbleIcon from '@mui/icons-material/Add';
import { styled } from '@mui/material/styles';
import { Button } from 'react-admin';

const StyledButton = styled(Button)({
  marginTop: '1em',
});

const AddMoreButton = ({ id, resource, target, from, tab }) => (
  <StyledButton
    variant="raised"
    component={Link}
    to={`/${resource}/create/?fastAdd=true&keyValue=${id}&keyName=${target}&tab=${tab}&backTo=${from}&addShortCut=true`}
    label="اضافة سجل جديد"
    title="اضافة سجل جديد"
  >
    <AddBubbleIcon />
  </StyledButton>
);

export default AddMoreButton;
